import styled from 'styled-components';

export const FormCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const FormCheckboxInput = styled.input`
  width: 1rem;
  height: 1rem;
  accent-color: ${({ theme }) => theme.colors.primary700};
`;

export const FormCheckboxLabel = styled.label`
  color: ${({ theme }) => theme.colors.neutral700};
  font-size: 0.875rem;
  cursor: pointer;
`;
